import axios from "axios";
//import moment from "moment";

export default {
    data() {
        return {
         //loader
          loader: "",
         //Timer
          TimerObject: {},
        }
    },

    methods: {
        loader_1() {
            this.loader = this.$loading.show({
                    // Optional parameters
                      color: '#03a9f3'
                    });
         },

        stageTabClick(ndx) {
            try {
                this.activeStageId = this.stages[ndx].stageId;
                this.activeStageNdx = ndx;
                let obj1 = this.dt1;
                for (let i = 0; i < obj1.length; i++) {
                    for (let j = 0; j < this.steps.length; j++) {
                        if (obj1[i].stageId == this.steps[j].stageId && obj1[i].stepId == this.steps[j].stepId) {
                            obj1[i].stepName = this.steps[j].stepName;
                            this.dt2[i].stepName=this.steps[j].stepName;
                            this.dt3[i].stepName=this.steps[j].stepName;
                        }
                    }
                }

                let objX = this.dt1.filter((f) => f.stageId === this.activeStageId);
                this.aDt1 = JSON.parse(JSON.stringify(objX));

                let objY = this.dt2.filter((f) => f.stageId === this.activeStageId);
                this.aDt2 = JSON.parse(JSON.stringify(objY));

                let objZ = this.dt3.filter((f) => f.stageId === this.activeStageId);
                this.aDt3 = JSON.parse(JSON.stringify(objZ));
            } catch {/**/ }
            //console.log("****", obj);
        },

        datePickerPR() {
            const self = this;
            $('input[name="daterangePR"]').daterangepicker(
                {
                    opens: "left",
                },
                function (start, end) {
                    self.startDatePR = new Date(start);
                    self.endDatePR = new Date(end);
                    self.initDatePR =
                        self.dateToMDY(self.startDatePR) +
                        " - " +
                        self.dateToMDY(self.endDatePR);
                }
            );
        },
         //Timer
         StartLogoutTime() {
            this.TimerObject = setTimeout(() => {
              this.AutoLogout();
            }, 1.8e+6);
          },
         ResetLogoutTime(){
            clearTimeout(this.TimerObject);
                this.TimerObject = setTimeout(() => {
                 this.AutoLogout();
                }, 1.8e+6);
          },

        loadInit() {
            const dd = new Date();
            dd.setDate(dd.getDate() - 30);

            this.startDatePR = dd;
            this.endDatePR = new Date();
            this.initDatePR =
                this.dateToMDY(this.startDatePR) +
                " - " +
                this.dateToMDY(this.endDatePR);

            this.StartLogoutTime();
            this.fetchInitData();
        },

        fetchInitData() {
            this.intDummyComm();
            if (this.selectedUsers.length > 0) {
                let aa = [];
                for (let i = 0; i < this.selectedUsers.length; i++)
                    aa.push(this.users[this.selectedUsers[i]].id);
                this.dummyComm.extras = aa.toString();
                //alert(this.selectedUsers.toString() + "    "+this.dummyComm.extras)
            } else this.dummyComm.extras = "";

            if (this.selectedPractice + "".length > 0) {
                this.dummyComm.extras1 = this.selectedPractice;
            } else this.dummyComm.extras1 = "";

            if (this.initDatePR.length > 0) {
                this.dummyComm.myDate = this.dateToSqlServerDateFormat(
                    this.startDatePR
                );
                this.dummyComm.myTime = this.dateToSqlServerDateFormat(this.endDatePR);
            } else {
                this.dummyComm.myDate = null;
                this.dummyComm.myTime = null;
            }

            //this.payments=[];
            //this.dummyComm.extras = "";
            const url = this.SERVER + "/VNSPRAAPI/Reports/WaitTimReportInitData";

            this.axiosGetData(url, 1);

            this.$nextTick(() => {
                $("#table001").DataTable().destroy();
                $("#table001").DataTable({
                    pageLength: 50,
                    lengthMenu: [
                      [50, 100, 500, 1000, 2000, -1],
                      [50, 100, 500, 1000, 2000],
                    ],
                    buttons: ["copy", "csv", "excel", "pdf", "print"],
                });
                $(
                    ".buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel"
                ).addClass("btn btn-primary mr-1");
                $(".table001").DataTable().draw();
            }); // this.$nextTick
        },

        //------------------------------------------ Common Methods
        async axiosGetData(myUrl, what) {
            var loader = this.$loading.show({
                // Optional parameters
                  color: '#03a9f3'
                });
            await axios({
                method: "post",
                url: myUrl,
                data: this.dummyComm, headers:{
                    Authorization: this.$store.getters.getAuthToken,
                  }
            })
                .then((res) => {
                    loader.hide();
                    // if everything goes well -- we will get data
                    this.lastErrorCode = 1;
                    if (what === 1) {
                        console.log(res.data);
                        this.users = res.data.users;
                        this.practices = res.data.practices;
                        this.stages = res.data.stages;
                        this.steps = res.data.steps;
                        this.dt1 = res.data.dt1;
                        this.dt2 = res.data.dt2;
                        this.dt3 = res.data.dt3;

                        this.activeStageId = this.stages[0].stageId;
                        this.stageTabClick(0);
                    }
                })
                .catch(function (error) {
                    if (error.response) {
                        this.lastErrorCode = 1;
                        alert("-> " + error.response.data);
                        alert("-> " + error.response.status);
                        alert("-> " + error.response.headers);
                    } else if (error.request) {
                        this.lastErrorCode = 1;
                        alert("No response " + error.request);
                    } else {
                        this.lastErrorCode = 1;
                        alert("Error", error.message);
                    }
                })
                .finally(() => {
                    this.ResetLogoutTime();
                    loader.hide(); });
        }, // axiosGetData

    }, // end methods

    watch: {
        initDatePR: function () {
            this.fetchInitData();
        },

        selectedUsers: function () {
            this.fetchInitData();
        },

        selectedPractice: function () {
            this.fetchInitData();
        },

        users: function (val) {
            this.usersList = [];
            for (let i = 0; i < val.length; i++) {
                this.usersList.push(val[i].name);
            }
        },

        practices: function () {
            this.practices.unshift({ value: -99, label: "" });
        },

        dt1: function () {
            let obj = this.dt1;
            for (let i = 0; i < obj.length; i++) {
                for (let j = 0; j < this.steps.length; j++) {
                    if (obj[i].stageId == this.steps[j].stageId && obj[i].stepId == this.steps[j].stepId) {
                        obj[i].stepName = this.steps[j].stepName;
                    }
                }
            }
        },


    }, // watch

    mounted() {
        this.loadInit();
        if(this.$store.getters.getAuthToken==="")
    {
        this.$store.commit('setAuthToken',localStorage.BeToken);
    }
    }, // mounted
    unmounted() {
        clearTimeout(this.TimerObject);
      },
}